import type { Timestamp } from "@bufbuild/protobuf";

export function isMockEnv() {
  const backendMode = import.meta.env.VITE_BACKEND_MODE;
  if (backendMode === "MOCK") {
    return true;
  }

  const { hostname } = location;
  const [tenantName] = hostname.split(".");
  return tenantName.endsWith("-mock");
}

export function getTenantSlug() {
  const { hostname } = location;

  const [tenantName, appName] = hostname.split(".");

  if (import.meta.env.VITE_TENANT_SLUG) {
    return import.meta.env.VITE_TENANT_SLUG;
  }

  if (appName === "console") {
    return tenantName;
  }

  return "demo";
}

export function getServiceId() {
  const tenantSlug = getTenantSlug();
  if (tenantSlug === "demo") {
    return import.meta.env.VITE_DEMO_SERVICE_ID;
  }
  if (tenantSlug === "miyagi") {
    return import.meta.env.VITE_MIYAGI_SERVICE_ID;
  }
  if (tenantSlug === "marumori") {
    return import.meta.env.VITE_MARUMORI_SERVICE_ID;
  }
  if (tenantSlug === "shiga-otsu") {
    return import.meta.env.VITE_SHIGAOTSU_SERVICE_ID;
  }
  if (tenantSlug === "shiga-otsu-pay") {
    return import.meta.env.VITE_SHIGA_OTSU_PAY_SERVICE_ID;
  }
  if (tenantSlug === "kyoto-kyoto") {
    return import.meta.env.VITE_KYOTO_KYOTO_SERVICE_ID;
  }
  if (tenantSlug === "hokkaido") {
    return import.meta.env.VITE_HOKKAIDO_SERVICE_ID;
  }
  throw new Error(`Unknown tenant slug: ${tenantSlug}`);
}

// .toLocalString() では非日本語環境で数字の区切りがドットになるケースがあるため、ja-JP を指定する
export function formatNumber(n: number | bigint | undefined): string {
  if (n === undefined) {
    return "";
  }
  return n.toLocaleString("ja-JP");
}

export function generateReadableId(length: number) {
  // 見るからに遅そうな書き方だがたいして使わなさそうなので一旦これでよい
  const chars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charsToExclude = "Ili1oO0";
  const filteredChars = chars
    .split("")
    .filter((char) => !charsToExclude.includes(char))
    .join("");
  let result = "";
  for (let i = 0; i < length; i++) {
    result += filteredChars.charAt(
      Math.floor(Math.random() * filteredChars.length)
    );
  }
  return result;
}

export const generateRandomNumericCode = (length: number): string => {
  const digits = Array.from({ length }, () => Math.floor(Math.random() * 10));
  return digits.join("");
};

export const getCompanyLoginUrl = (): string => {
  const origin = window.location.origin;
  return `${origin}/login/company`;
};

export const getStoreLoginUrl = (): string => {
  const origin = window.location.origin;
  return `${origin}/login/store`;
};

/**
 * 店舗の利用状態を判定する
 * @param openedAt 利用開始日
 * @param closedAt 利用終了日
 * @returns 利用中の場合true、利用停止中の場合false
 */
export const isStoreActive = (
  openedAt?: Date | Timestamp | null,
  closedAt?: Date | Timestamp | null
): boolean => {
  const now = new Date();

  // openedAtが未設定または現在日時より前
  const openedAtDate = openedAt instanceof Date ? openedAt : openedAt?.toDate();
  const isOpened = !openedAt || !openedAtDate || now >= openedAtDate;

  // closedAtが未設定または現在日時より後
  const closedAtDate = closedAt instanceof Date ? closedAt : closedAt?.toDate();
  const isNotClosed = !closedAt || !closedAtDate || now <= closedAtDate;

  return isOpened && isNotClosed;
};
